import { dynamic } from '#/utils/dynamic';

export const DynamicSearchOrgsRefinements = dynamic(
  () =>
    import('./SearchOrgsRefinements').then((m) => ({
      default: m.SearchOrgsRefinements,
    })),
  { strategy: 'client-only' },
);
